<!-- 目标进度组件 -->
<template>
  <div class="chat-card">
    <div class="chat-title">
      <span>目标</span>
    </div>
    <div class="target-list">
      <template v-for="(item, index) in cardDataInput">
        <div class="target-item" :key="index">
          <div class="target">
            <div class="name">目标{{index + 1}}：{{ item.goal }}</div>
          </div>
          <DraggableProgressBar v-model="item.value" bg-color="rgba(121, 72, 234, 1)" container-bg-color="#ffffff"  />
        </div>
      </template>
    </div>
    <button v-if="isCanEdit" class="confirm-btn" @click="confirmFn">确定</button>
  </div>
</template>

<script>

import {DraggableProgressBar} from '@/components'
export default {
  name: 'ChatTextarea',
  components: {
    DraggableProgressBar
  },
  props: {
    cardData: {
      type: Object,
      required: true
    },
    // 是否可编辑
    isCanEdit: {
      type: Boolean,
      default: true,
    },
    nextData: {
      type: Object,
      default: () => {
        return null;
      },
    }
  },
  data () {
    return {
      cardDataInput: null
    }
  },
  mounted() {
    if(this.isCanEdit) {
      this.cardDataInput = this.cardData.step_data.instance_data[2].answer.goals.map(item => {
        return {
          ...item,
          value: 50
        }
      });
    } else {
      if(this.nextData?.step_data?.survey?.qstList[0].answer.val) {
        let useData = this.nextData.step_data.survey.qstList[0].answer.val;
        this.cardDataInput = useData;
      }
    }
  },
  methods: {
    confirmFn() {
      let useData = {
        id: this.cardData.id,
        step_id: this.cardData.step_id,
        step_data: {
          survey: {
            id: this.cardData.instance_id,
            surveyType: 2,
            qstList: [
              {
                qstCode: this.cardData.step_type,
                answer: {
                  val: this.cardDataInput
                },
              },
            ],
          },
        },
      };
      this.$emit('confirmFn', useData);
    },
  },
};
</script>

<style scoped lang="scss">
.target-item {
  margin-bottom: 10px;
}
.target {
  display: flex;
  margin-bottom: 17px;
  .name {
    font-size: 12px;
    font-weight: 500;
    line-height: 23px;
    color: rgba(59, 59, 59, 1);
    text-align: left;
  }
  input {
    flex: 1;
    box-sizing: border-box;
    padding: 1px 8px;
    border: none;
    border-radius: 6px;
    background: rgba(255, 255, 255, 1);
    font-size: 10px;
    font-weight: 400;
    line-height: 23px;
    text-align: left;
    vertical-align: top;
  }
}
.chat-card {
  width: 342px;
  border-radius: 12px;
  padding: 10px 12px;
  background: #e8e3fc;
  box-sizing: border-box;
  .chat-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 7px;
    span {
      font-size: 14px;
      font-weight: 500;
      line-height: 23px;
      color: rgba(59, 59, 59, 1);
    }
    img {
      width: 21px;
      height: 21px;
    }
  }
  .textarea {
    width: 100%;
    height: 144px;
    padding: 16px;
    box-sizing: border-box;
    margin-top: 5px;
    margin-left: -2px;
    line-height: 15px;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0px;
    border: none;
    border-radius: 7px;
    background: rgba(255, 255, 255, 1);
    display: block;
    &::placeholder {
      font-weight: 300;
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .confirm-btn {
    width: 76px;
    height: 25px;
    border-radius: 12px;
    background: #AD7EFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 400;
    letter-spacing: 0.23px;
    color: #fff;
    border: none;
    margin: 9px auto 0;
  }
}
.bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.help {
  font-size: 10px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(121, 72, 234, 0.62);
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9D9FA3;
  margin-top: 4px;
}
</style>
